import React, { useState, useEffect, useCallback } from 'react';
import { useRedux } from 'services/gecko-store/redux';
// import { connect } from 'react-redux';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { fromNow } from 'utilities/fromNowWrapper.js';
import {
  // GECKO_UTILS,
  GeckoRow,
  GeckoCol,
  GeckoBtn,
  GeckoFields,
  GeckoToastService,
  // GeckoModalService
} from 'ui';
import { fetchContactNotes } from '../../actions.js';

function NoteComposer({ value, saveButtonText, onSave, onCancel }) {
  const [newNoteValue, setNewNoteValue] = useState(value);
  const field = {
    key: 'note',
    type: 'textarea',
    width: '12',
    config: {
      placeholder: 'Write a note',
    },
  };

  return (
    <div className="note-composer-wrapper">
      <div className="note-composer">
        <GeckoFields
          fields={[field]}
          values={{ note: newNoteValue }}
          handler={(_, value) => setNewNoteValue(value)}
        />
        <GeckoRow>
          <GeckoCol width="12">
            <div className="notes-buttons">
              <GeckoBtn
                className="btn-sm"
                name="Cancel"
                icon="far fa-times"
                type="default"
                handler={onCancel}
              />
              <GeckoBtn
                className="btn-sm"
                name={saveButtonText}
                icon="far fa-check-double"
                type="primary"
                handler={() => onSave(newNoteValue)}
              />
            </div>
          </GeckoCol>
        </GeckoRow>
      </div>
    </div>
  );
}

function Note({ note, onEditClick, onDeleteClick }) {
  return (
    <div className="note-single">
      <div>{note.text}</div>
      <div className="note-meta">
        <span title={note.createdAt}>{fromNow(note.createdAt)}</span>
        <span className="separator">&middot;</span>
        <a className="edit-note actionBtn" onClick={onEditClick}>
          Edit
        </a>
        <span className="separator">&middot;</span>
        <a className="delete-note actionBtn" onClick={onDeleteClick}>
          Delete
        </a>
      </div>
    </div>
  );
}

function Notes({ contact, notes = [] }) {
  const [isEditing, setIsEditing] = useState(false);
  const [noteBeingEditted, setNoteBeingEddited] = useState(null);

  const closeEditMode = () => {
    setNoteBeingEddited(null);
    setIsEditing(false);
  };

  const openNoteToEdit = (note) => {
    setNoteBeingEddited(note);
    setIsEditing(true);
  };

  const addNote = (noteValue) => {
    if (noteValue !== '') {
      return GeckoRequest.post('/note', {
        notableType: 'user',
        notableId: contact.id,
        text: noteValue,
      })
        .then(() => new GeckoToastService().success('New Note Added'))
        .then(() => closeEditMode())
        .catch(renderError);
    }
  };

  const deleteNote = (note) => {
    return GeckoRequest.delete('/note/' + note.id)
      .then(() => new GeckoToastService().success('Note Deleted'))
      .catch(renderError);
  };

  const editNote = (noteValue) => {
    if (noteValue !== '') {
      return GeckoRequest.post('/note/' + noteBeingEditted.id, {
        text: noteValue,
      })
        .then(() => new GeckoToastService().success('Note Updated'))
        .then(() => closeEditMode())
        .catch(renderError);
    }
  };

  const renderUpdateComposer = (note) => (
    <NoteComposer
      value={note.text}
      saveButtonText="Update"
      onSave={editNote}
      onCancel={closeEditMode}
    />
  );
  const renderNewComposer = () => (
    <NoteComposer
      value={''}
      saveButtonText="Add"
      onSave={addNote}
      onCancel={closeEditMode}
    />
  );
  const renderComposer = () =>
    noteBeingEditted === null
      ? renderNewComposer()
      : renderUpdateComposer(noteBeingEditted);

  const renderFeed = () => {
    return (
      <div className="notes-feed">
        {notes.map((note) => {
          return (
            <Note
              key={note.id}
              note={note}
              onEditClick={() => openNoteToEdit(note)}
              onDeleteClick={() => deleteNote(note)}
            />
          );
        })}
        {!notes.length ? (
          <div className="about-notes">
            Notes help you keep track of your conversations. Only Agents can see notes.
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className="contact-notes-box">
      {renderFeed()}
      {isEditing ? renderComposer() : null}
      {!isEditing ? (
        <div className="note-button">
          <GeckoBtn
            name="Add Note"
            icon="far fa-sticky-note"
            type="default"
            className="btn-sm"
            handler={() => setIsEditing(true)}
          />
        </div>
      ) : null}
    </div>
  );
}

export default Notes;
